<script setup lang="ts">
import type { ReorderAxis } from '~/composables/orga/reorder/reorderModel'

const props = defineProps<{
  groupId: string
  itemKey: string
  label: string
  position: number
  total: number
  axis: ReorderAxis
}>()

const emit = defineEmits<{
  move: [groupId: string, keyName: string, fromIndex: number]
}>()

const moveKeys = computed(() =>
  props.axis === 'vertical'
    ? ['ArrowUp', 'ArrowDown', 'Home', 'End']
    : ['ArrowLeft', 'ArrowRight', 'Home', 'End'],
)

function onKeydown(event: KeyboardEvent): void {
  if (!moveKeys.value.includes(event.key)) {
    return
  }
  event.preventDefault()
  event.stopPropagation()
  emit('move', props.groupId, event.key, props.position - 1)
}
</script>

<template>
  <button
    type="button"
    class="org-reorder-handle"
    :data-reorder-handle="`${groupId}:${itemKey}`"
    :aria-label="`Déplacer ${label}, position ${position} sur ${total}`"
    :aria-keyshortcuts="axis === 'vertical' ? 'ArrowUp ArrowDown Home End' : 'ArrowLeft ArrowRight Home End'"
    @keydown="onKeydown"
    @click.stop
  >
    <span class="material-symbols-outlined" aria-hidden="true">drag_indicator</span>
  </button>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/elpdl/colors" as colors;
@use "~/assets/scss/partials/elpdl/spacing" as spacing;

.org-reorder-handle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  margin: 0;
  padding: spacing.$spacing-2xs;
  border: none;
  border-radius: spacing.$spacing-2xs;
  background: transparent;
  color: colors.$enedis-primary-600;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  &:focus-visible {
    outline: 2px solid colors.$enedis-primary-500;
    outline-offset: 2px;
  }

  .material-symbols-outlined {
    font-size: 1.25rem;
  }
}
</style>
